import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=0ad445e0"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=0ad445e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports